import { FC, ReactNode } from 'react';
import { cn } from '@design-system';

export interface TabButtonProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  icon?: ReactNode;
  className?: string;
}

export const TabButton: FC<TabButtonProps> = ({ label, isSelected, onClick, icon, className = '' }) => (
  <li className={cn("mr-2 flex", className)}>
    <button
      className={cn(
        "inline-flex flex-1 items-center justify-center px-4 py-4 border-b-2 rounded-t-lg transition-colors",
        isSelected
          ? "text-brand border-brand bg-brand-subtle dark:bg-brand-muted/20 font-semibold"
          : "border-transparent text-muted hover:text-secondary hover:border-border-strong hover:bg-surface-muted dark:hover:bg-surface-muted/50",
      )}
      onClick={onClick}
      aria-current={isSelected ? "page" : undefined}
    >
      {icon && <span className="mr-2">{icon}</span>}
      <span>{label}</span>
    </button>
  </li>
);
